import React from 'react';
import { Card, CardBody, Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';

class AddWordInputGroup extends React.Component {
  render() {
    return (
      <Card className="bg-light h-100 text-center" style={{ borderStyle: "dashed" }}>
        <CardBody>
          <h5 className="text-muted mt-5 pt-5">Paspauskite norėdami pridėti naują laukelį</h5>
          <Button outline color="secondary" type="button" size="lg" onClick={this.props.addCard}>
            <FontAwesomeIcon size="lg" icon={faPlus}/>
          </Button>{' '}
        </CardBody>
      </Card>
    );
  }
}

export default AddWordInputGroup;

